<script>
</script>

<svg
  on:click
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  class={$$props.class}
>
  <path
    d="M4.29279 7.30529C4.48031 7.11782 4.73462 7.0125 4.99979 7.0125C5.26495 7.0125 5.51926 7.11782 5.70679 7.30529L11.9998 13.5983L18.2928 7.30529C18.385 7.20978 18.4954 7.1336 18.6174 7.08119C18.7394 7.02878 18.8706 7.00119 19.0034 7.00004C19.1362 6.99888 19.2678 7.02419 19.3907 7.07447C19.5136 7.12475 19.6253 7.199 19.7192 7.29289C19.8131 7.38679 19.8873 7.49844 19.9376 7.62133C19.9879 7.74423 20.0132 7.87591 20.012 8.00869C20.0109 8.14147 19.9833 8.27269 19.9309 8.39469C19.8785 8.5167 19.8023 8.62704 19.7068 8.71929L12.7068 15.7193C12.5193 15.9068 12.265 16.0121 11.9998 16.0121C11.7346 16.0121 11.4803 15.9068 11.2928 15.7193L4.29279 8.71929C4.10532 8.53176 4 8.27745 4 8.01229C4 7.74712 4.10532 7.49282 4.29279 7.30529Z"
    fill="#032B01"
  />
</svg>

<style>
  .country {
    position: absolute;
    right: 10px;
    width: 13px;
  }
  .country.active {
    transform: rotate(180deg);
  }
  @media only screen and (max-width: 768px) {
    svg.contribution {
      top: 15px;
      right: 15px;
    }
  }
  @media only screen and (max-width: 480px) {
    svg.gender {
      top: 15px;
      right: 15px;
    }
    svg.contribution {
      top: 16px;
      right: 15px;
      max-width: 20px;
    }
  }
</style>
